module.exports = __webpack_public_path__ + "img/microsoft_imagotype.e90c520f.png";